import { HighlightLogo } from '@highlight/ui'
import type { SetupCallMoment } from '../schedule'

interface SetupCallEarProps {
  moment: SetupCallMoment
  onOpen: () => void
}

const earClassName =
  'text-foreground flex h-7 items-center gap-1.5 whitespace-nowrap rounded-lg px-2 text-sm font-medium'

/** The left ear: the mark, and three days on "Setup call" beside it, so the right ear can say "Pick a time". */
export function SetupCallLeadEar({ moment, onOpen }: SetupCallEarProps) {
  return (
    <button type="button" className={earClassName} onClick={onOpen} aria-label="Setup call. Show the invite">
      <HighlightLogo size={16} tone="light" aria-hidden>
        <HighlightLogo.Icon />
      </HighlightLogo>
      {moment === 'later' && <span>Setup call</span>}
    </button>
  )
}

export function SetupCallLabelEar({ moment, onOpen }: SetupCallEarProps) {
  return (
    <button type="button" className={earClassName} onClick={onOpen} aria-label="Setup call. Show the invite">
      {moment === 'later' ? <span className="text-foreground-secondary">Pick a time</span> : <span>Setup call</span>}
    </button>
  )
}
